'use strict';

exports.__esModule = true;

var _styledBase = require('@emotion/styled-base');

var _styledBase2 = _interopRequireDefault(_styledBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return 'You have tried to stringify object returned from `css` function. It isn\'t supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).'; }

var PoweredByImage = (0, _styledBase2.default)('img', {
	target: 'e1eb5iy50',
	label: 'PoweredByImage'
})(process.env.NODE_ENV === 'production' ? {
	name: '14kcwr6',
	styles: 'width:110px;'
} : {
	name: '14kcwr6',
	styles: 'width:110px;',
	map: '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHlsZXMvUG93ZXJlZEJ5SW1hZ2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRWlDIiwiZmlsZSI6Ii4uLy4uL3NyYy9zdHlsZXMvUG93ZXJlZEJ5SW1hZ2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmNvbnN0IFBvd2VyZWRCeUltYWdlID0gc3R5bGVkLmltZ2Bcblx0d2lkdGg6IDExMHB4O1xuYDtcblxuZXhwb3J0IGRlZmF1bHQgUG93ZXJlZEJ5SW1hZ2U7XG4iXX0= */',
	toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

exports.default = PoweredByImage;